import { render, staticRenderFns } from "./LibraryImageModal.vue?vue&type=template&id=884083a6&scoped=true&"
import script from "./LibraryImageModal.vue?vue&type=script&lang=js&"
export * from "./LibraryImageModal.vue?vue&type=script&lang=js&"
import style0 from "./LibraryImageModal.vue?vue&type=style&index=0&id=884083a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884083a6",
  null
  
)

export default component.exports